import * as tslib_1 from "tslib";
import * as React from 'react';
import Icon from '../Icon';
/*eslint-disable */
/*tslint:disable */
var DropdownArrow = function (props) { return (React.createElement(Icon, tslib_1.__assign({ viewBox: "0 0 11 7" }, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M10.073 1.69L9.345.926 5.073 5.4.802.927l-.729.762 5 5.238z", fill: "currentColor", fillRule: "evenodd" })))); };
/*tslint:enable */
/*eslint-enable */
export default DropdownArrow;
//# sourceMappingURL=DropdownArrow.js.map